module.exports = __webpack_public_path__ + "static/media/irish-life.2eaef095.png";